import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'consegna',
    [ORDER_METHODS.PICKUP]: 'asporto',
    [ORDER_METHODS.ROOM_SERVICE]: 'in loco',
  },
  feedback: {
    payment_method_disabled: 'Non accettiamo pagamenti {{paymentMethod}} per ordini di {{orderMethod}}',
    cash_disabled: 'Non accettiamo pagamenti in contanti per ordini di {{orderMethod}}',
  },
};
